import React from 'react';
import { Box, TextField, FormControl, InputLabel, Select, MenuItem, Alert } from '@mui/material';
import { CustomerData, CustomerUpdateData } from '../../types/newTripForm';

interface CustomerEditFormProps {
  customerEditData: CustomerUpdateData;
  customer: CustomerData;
  customerUpdateError: string;
  handleCustomerEditChange: (field: keyof CustomerUpdateData) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  setCustomerEditData: React.Dispatch<React.SetStateAction<CustomerUpdateData>>;
  customerEditFieldSx?: any;
  customerEditFieldDisabledSx?: any;
  customerEditSelectSx?: any;
  customerEditAddressSx?: any;
}

const CustomerEditForm: React.FC<CustomerEditFormProps> = ({
  customerEditData,
  customer,
  customerUpdateError,
  handleCustomerEditChange,
  setCustomerEditData,
  customerEditFieldSx,
  customerEditFieldDisabledSx,
  customerEditSelectSx,
  customerEditAddressSx
}) => (
  <Box>
    {customerUpdateError && (
      <Alert severity="error" sx={{ mb: 2 }}>
        {customerUpdateError}
      </Alert>
    )}
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 2 }}>
      <TextField
        fullWidth
        label="Name"
        value={customerEditData.name}
        onChange={handleCustomerEditChange('name')}
        variant="outlined"
        size="small"
        sx={customerEditFieldSx}
      />
      <TextField
        fullWidth
        label="Mobile Number"
        value={customer?.mobileNumber || ''}
        variant="outlined"
        size="small"
        disabled
        sx={customerEditFieldDisabledSx}
      />
      <TextField
        fullWidth
        label="Email"
        value={customerEditData.email}
        onChange={handleCustomerEditChange('email')}
        variant="outlined"
        size="small"
        type="email"
        sx={customerEditFieldSx}
      />
      <FormControl fullWidth size="small">
        <InputLabel>Gender</InputLabel>
        <Select
          value={customerEditData.gender}
          label="Gender"
          onChange={(e) => setCustomerEditData((prev) => ({ ...prev, gender: e.target.value }))}
          sx={customerEditSelectSx}
        >
          <MenuItem value="">Select Gender</MenuItem>
          <MenuItem value="Male">Male</MenuItem>
          <MenuItem value="Female">Female</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </Select>
      </FormControl>
      <TextField
        fullWidth
        label="Address"
        value={customerEditData.address}
        onChange={handleCustomerEditChange('address')}
        variant="outlined"
        size="small"
        multiline
        rows={2}
        sx={customerEditAddressSx}
      />
    </Box>
  </Box>
);

export default CustomerEditForm;